module.exports = __webpack_public_path__ + "img/F1F6_new.e0ccfed0.jpg";